import { useAtom, atom } from 'jotai';

export const selectedWorkflowTabAtom = atom<number>(0);

export const useWorkflowTabs = () => {
  const [selectedTab, setSelectedTab] = useAtom(selectedWorkflowTabAtom);

  const handleTabChange = (tabIndex: number) => {
    setSelectedTab(tabIndex);
  };
  return {
    handleTabChange,
    selectedTab,
  };
};
